import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import React, { useEffect, useState } from "react";
import { initialLabel, initialRules, intialObj } from "./Constant";
import { Button, Col, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { FiEdit } from "react-icons/fi";
import { useForm } from "app/_helpers/hooks";
import FormInput from "app/Components/_form/FormInput/FormInput";
import FormTextArea from "app/Components/_form/FormTextArea/FormTextArea";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { Validation } from "app/_helpers/validation/Validation";
import toastr from "toastr";

const WorkflowRoleList = () => {
  const [workflowRoleData, setWorkflowRoleData] = useState([]);
  const [showManageModal, setShowManageModal] = useState(false);
  const [fetchRow, onChange, setFetchRow] = useForm({ ...intialObj });
  const [error, setError] = useState({});

  //   let workflowRoleData = [
  //     {
  //       roleLevel: "Global",
  //       systemRoleName: "Mines Safety Officer",
  //       systemDescription: "dd1",
  //       displayRoleName: "Display Mines Safety Officer",
  //       displayDescription: "disdd1",
  //     },
  //     {
  //       roleLevel: "Incident Management",
  //       systemRoleName: "Reporting Officer",
  //       systemDescription: "dd1",
  //       displayRoleName: "Display Reporting Officer",
  //       displayDescription: "disdd1",
  //     },
  //     {
  //       roleLevel: "VFL",
  //       systemRoleName: "VFL Executive",
  //       systemDescription: "dd1",
  //       displayRoleName: "Display VFL Executive",
  //       displayDescription: "disdd1",
  //     },
  //     {
  //       roleLevel: "Global",
  //       systemRoleName: "HR Manager - Mines",
  //       systemDescription: "dd1",
  //       displayRoleName: "Display HR Manager - Mines",
  //       displayDescription: "disdd1",
  //     },
  //     {
  //       roleLevel: "Incident Management",
  //       systemRoleName: "Investigator",
  //       systemDescription: "dd1",
  //       displayRoleName: "Display Investigator",
  //       displayDescription: "disdd1",
  //     },
  //   ];

  const sortableColumn = [
    {
      dataField: "sid",
      text: "S.No.",
      sort: true,
    },
    {
      dataField: "roleLevel",
      text: initialLabel.roleLevel,
      sort: true,
      //   formatter: (id, row) => escalationEventLabel[row?.event] || "",
    },
    {
      dataField: "systemRoleName",
      text: initialLabel.systemRoleName,
      sort: true,
    },
    {
      dataField: "systemDescription",
      text: initialLabel.systemDescription,
      sort: true,
    },
    {
      dataField: "displayRoleName",
      text: initialLabel.displayRoleName,
      sort: true,
    },
    {
      dataField: "displayDescription",
      text: initialLabel.displayDescription,
      sort: true,
    },

    {
      dataField: "id",
      text: "Action",
      formatter: (id, row) => {
        return (
          <div className="actionIconsGroup">
            {/* <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">View</Tooltip>}
            >
              <span
                className="icons text-cyanBlue"
                onClick={() => {
                  setShowManageModal(true);
                  setDefaultTem(false);
                  setModalData(row);
                }}
              >
                <FiEye />
              </span>
            </OverlayTrigger> */}

            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Update</Tooltip>}
            >
              <span
                className="icons text-cyanBlue"
                onClick={() => {
                  setShowManageModal(true);
                  setFetchRow(row);
                }}
              >
                <FiEdit />
              </span>
            </OverlayTrigger>
          </div>
        );
      },
    },
  ];

  const fetchData = async () => {
    const response = await CommmonService.getAllWorkflowRole();
    if (!response?.status) return;
    setWorkflowRoleData(response?.data || []);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSubmit = async () => {
    const errorObj = Validation(fetchRow, initialRules);
    setError(errorObj);
    if (Object.values(errorObj).filter((d) => d !== "").length) return;

    let response = await CommmonService.updateWorkflowRole(fetchRow?.id, fetchRow);

    if (!response?.status) return toastr.error(response?.message);
    toastr.success(response?.message);
    setShowManageModal(false);
    setFetchRow({ ...intialObj });
    fetchData();
  };

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Admin Panel", path: "#" },
          { name: "Workflow Roles", path: "#" },
        ]}
        breadCrumbsText="User_Management_User_Registration"
      />
      <div className="healthSafetyEnvironmentWrapper">
        <div className="p-2">
          <div className="card p-3 mt-3">
            <div className="simple-card-title">
              <h3 className="text-capitalize mb-1">Workflow Roles</h3>
            </div>
            <>
              <SearchBootstrapTable
                data={workflowRoleData}
                columns={sortableColumn}
                tableDownloadFlag={false}
              />
            </>
          </div>
        </div>
      </div>
      <Modal show={showManageModal} backdrop="static" size="lg">
        <div className="card" style={{ overflow: "visible" }}>
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-between simple-card-title">
              <h3 className="text-capitalize mb-1">{`Edit Workflow Roles`}</h3>
            </div>
            <div className="ehsFormWrapper">
              <Row className="pt-1">
                <Col lg={12}>
                  <FormInput
                    name="roleLevel"
                    value={fetchRow.roleLevel}
                    type="text"
                    class="form-control"
                    placeholder=""
                    label={initialLabel.roleLevel}
                    readOnly
                  />
                </Col>
                <Col lg={6}>
                  <FormInput
                    name="systemRoleName"
                    value={fetchRow.systemRoleName}
                    type="text"
                    class="form-control"
                    placeholder=""
                    label={initialLabel.systemRoleName}
                    onChange={onChange}
                    error={error?.systemRoleName}
                  />
                </Col>

                <Col lg={6}>
                  <FormInput
                    name="displayRoleName"
                    value={fetchRow.displayRoleName}
                    onChange={onChange}
                    type="text"
                    class="form-control"
                    placeholder=""
                    label={initialLabel.displayRoleName}
                    error={error?.displayRoleName}
                  />
                </Col>

                <Col lg={6}>
                  <FormTextArea
                    name="systemDescription"
                    value={fetchRow.systemDescription}
                    onChange={onChange}
                    class="form-control"
                    label={initialLabel.systemDescription}
                    error={error?.systemDescription}
                  />
                </Col>

                <Col lg={6}>
                  <FormTextArea
                    name="displayDescription"
                    value={fetchRow.displayDescription}
                    onChange={onChange}
                    class="form-control"
                    label={initialLabel.displayDescription}
                    error={error?.displayDescription}
                  />
                </Col>
              </Row>
            </div>
            <div className="mt-2 text-center">
              <Button
                onClick={() => {
                  setShowManageModal(false);
                  setFetchRow({});
                  setError({});
                }}
                className="btn btn-secondary mr-2"
              >
                Close
              </Button>

              <Button
                onClick={() => onSubmit()}
                variant="primary"
                className="m-1 text-capitalize"
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default WorkflowRoleList;
